import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { useLang } from "../i18n";

export default function NotFound() {
  const { l, t } = useLang();
  const p = t.notFound;
  return (
    <>
      <Seo title={p.seo.title} description={p.seo.description} path="/404" />
      <section className="max-w-3xl mx-auto px-5 md:px-10 pt-40 md:pt-52 pb-28 text-left">
        <p className="eyebrow mb-5">{p.eyebrow}</p>
        <h1 className="font-serif text-4xl sm:text-5xl leading-tight text-ink">
          {p.h1}
        </h1>
        <p className="mt-6 text-base text-body leading-relaxed max-w-xl">
          {p.text}
        </p>
        <div className="mt-8 flex flex-wrap gap-4">
          <Link
            to={l("/")}
            data-testid="notfound-home-link"
            className="inline-flex items-center rounded-full bg-sage px-7 py-3.5 text-sm font-semibold text-cream transition-colors duration-300 hover:bg-sage-dark"
          >
            {p.home}
          </Link>
          <Link
            to={l("/camere")}
            data-testid="notfound-rooms-link"
            className="inline-flex items-center rounded-full border border-sage px-7 py-3.5 text-sm font-medium text-sage transition-colors duration-300 hover:bg-sage hover:text-cream"
          >
            {p.rooms}
          </Link>
        </div>
      </section>
    </>
  );
}
